import { configurator } from './configurator-common';

export const en = {
  configurator,
};
